import { IWPItem, WPItem } from "@/loader";

export interface IWPPostBase extends IWPItem {
	content?: {
		raw?: string;
		rendered?: string;
		protected?: boolean;
		block_version?: number;
	};
	excerpt?: {
		raw?: string;
		rendered?: string;
		protected?: boolean;
	};
	featured_media?: number;
}

export class WPPostBase extends WPItem implements IWPPostBase {
	public content!: {
		raw?: string;
		rendered?: string;
		protected?: boolean;
		block_version?: number;
	};
	public excerpt!: {
		raw?: string;
		rendered?: string;
		protected?: boolean;
	};
	public featured_media!: number;

	constructor(data: IWPPostBase = {}) {
		super();
		this.load(data);
	}

	public load(data: IWPPostBase) {
		super.load(data);
		this.featured_media = Number.orDefault(data.featured_media);
		this.content = {
			raw: String.orDefault(data.content?.raw),
			rendered: String.orDefault(data.content?.rendered),
			protected: Boolean.orDefault(data.content?.protected),
			block_version: Number.orDefault(data.content?.block_version),
		};
		this.excerpt = {
			raw: String.orDefault(data.excerpt?.raw),
			rendered: String.orDefault(data.excerpt?.rendered),
			protected: Boolean.orDefault(data.excerpt?.protected),
		};
	}

	public update(data: IWPPostBase) {
		super.update(data);
		if (data.featured_media !== undefined) {
			this.featured_media = Number.orDefault(data.featured_media);
		}
		if (data.content !== undefined) {
			if (data.content.raw !== undefined) {
				this.content.raw = String.orDefault(data.content.raw);
			}
			if (data.content.rendered !== undefined) {
				this.content.rendered = String.orDefault(data.content.rendered);
			}
			if (data.content.protected !== undefined) {
				this.content.protected = Boolean.orDefault(data.content.protected);
			}
			if (data.content.block_version !== undefined) {
				this.content.block_version = Number.orDefault(data.content.block_version);
			}
		}
		if (data.excerpt !== undefined) {
			if (data.excerpt.raw !== undefined) {
				this.excerpt.raw = String.orDefault(data.excerpt.raw);
			}
			if (data.excerpt.rendered !== undefined) {
				this.excerpt.rendered = String.orDefault(data.excerpt.rendered);
			}
			if (data.excerpt.protected !== undefined) {
				this.excerpt.protected = Boolean.orDefault(data.excerpt.protected);
			}
		}
	}

	public restData() {
		return {
			...super.restData(),
			content: this.content.raw,
			excerpt: this.excerpt.raw,
			featured_media: this.featured_media,
		};
	}
}
